import { SET_MY_ACCOUNT_VIEW_STATUS, SET_SECURITY_PERMITS } from "./mutation-types";

const mutations = {
  [SET_MY_ACCOUNT_VIEW_STATUS](state, settings) {
    state.settings = settings;
  },
  [SET_SECURITY_PERMITS](state, settings) {
    state.settings = settings;
  },
};

export default mutations;
